module.exports = __webpack_public_path__ + "media/images/flags/4x3/mys-645d2fbfdea51a5b71e3fbc29215085a.svg";